export default __webpack_public_path__ + "static/IN-9008_Lenses_16mm_auto_15m_tag_zoom-f1ddd4618268636ae2f37cc38e983759.webp";